module.exports = __webpack_public_path__ + "static/media/iq.0ab76ff4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/iq.svg
// module id = 152
// module chunks = 0